// extracted by mini-css-extract-plugin
export var expiresOnChip = "LinkCard-module--expires-on-chip--c8d58";
export var titleNoDescription = "LinkCard-module--title-no-description--ab437";